module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-form', {
    staticStyle: {
      "min-height": "90vh"
    },
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_vm._l((_vm.row.member_list), function(member, index) {
    return _c('div', {
      key: index
    }, [_c('van-divider', [_vm._v("人员信息" + _vm._s(index + 1) + "\n        ")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "readonly": "",
        "input-align": "right",
        "title": '人员' + (index + 1),
        "label": member.num,
        "value": member.name
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "readonly": "",
        "rules": [{
          required: true,
          message: '请输入正确的手机号'
        }],
        "error-message-align": "right",
        "label": "手机",
        "input-align": "right",
        "clearable": "",
        "placeholder": "请输入手机"
      },
      model: {
        value: (member.phone),
        callback: function($$v) {
          _vm.$set(member, "phone", $$v)
        },
        expression: "member.phone"
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "center": "",
        "title": "是否需要接站"
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c('van-switch', {
            attrs: {
              "active-color": "#ffad19",
              "active-value": 1,
              "inactive-value": 2,
              "size": "24"
            },
            model: {
              value: (member.need_jie),
              callback: function($$v) {
                _vm.$set(member, "need_jie", $$v)
              },
              expression: "member.need_jie"
            }
          })]
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), (member.need_jie == 1) ? _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "label": "接站时间",
        "input-align": "right",
        "error-message-align": "right",
        "placeholder": "请选择接站时间",
        "rules": [{
          required: true,
          message: '请选择接站时间'
        }]
      },
      on: {
        "click": function($event) {
          _vm.thisMemberIndex = index;
          _vm.showJieDate = true
        }
      },
      model: {
        value: (member.jie_date),
        callback: function($$v) {
          _vm.$set(member, "jie_date", $$v)
        },
        expression: "member.jie_date"
      }
    }) : _vm._e(), _vm._v(" "), _c('van-popup', {
      attrs: {
        "position": "bottom"
      },
      model: {
        value: (_vm.showJieDate),
        callback: function($$v) {
          _vm.showJieDate = $$v
        },
        expression: "showJieDate"
      }
    }, [_c('van-datetime-picker', {
      attrs: {
        "type": "datetime",
        "title": "选择年月日",
        "min-date": _vm.minDate,
        "max-date": _vm.maxDate
      },
      on: {
        "confirm": _vm.onJieDateConfirm,
        "cancel": function($event) {
          _vm.showJieDate = false
        }
      },
      model: {
        value: (_vm.currentJieDate),
        callback: function($$v) {
          _vm.currentJieDate = $$v
        },
        expression: "currentJieDate"
      }
    })], 1), _vm._v(" "), (member.need_jie == 1) ? _c('van-field', {
      attrs: {
        "label-width": "10em",
        "rules": [{
          required: true,
          message: '请输入车次/航班号'
        }],
        "error-message-align": "right",
        "label": "接站车次/航班号",
        "input-align": "right",
        "clearable": "",
        "placeholder": "请输入车次/航班号"
      },
      model: {
        value: (member.jie_code),
        callback: function($$v) {
          _vm.$set(member, "jie_code", $$v)
        },
        expression: "member.jie_code"
      }
    }) : _vm._e(), _vm._v(" "), (member.need_jie == 1) ? _c('div', {
      staticClass: "operate-desc-left"
    }, [_vm._v("海口美兰机场接站航班号")]) : _vm._e(), _vm._v(" "), (member.need_jie == 1) ? _c('van-field', {
      attrs: {
        "label-width": "10em",
        "error-message-align": "right",
        "label": "接站额外同行人数",
        "input-align": "right",
        "clearable": "",
        "placeholder": "请输入接站额外同行人数"
      },
      on: {
        "click": function($event) {
          return _vm.Toast('人数不可修改')
        }
      },
      model: {
        value: (member.jie_count),
        callback: function($$v) {
          _vm.$set(member, "jie_count", $$v)
        },
        expression: "member.jie_count"
      }
    }) : _vm._e(), _vm._v(" "), _c('van-cell', {
      attrs: {
        "center": "",
        "title": "是否需要送站"
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c('van-switch', {
            attrs: {
              "active-color": "#ffad19",
              "active-value": 1,
              "inactive-value": 2,
              "size": "24"
            },
            model: {
              value: (member.need_song),
              callback: function($$v) {
                _vm.$set(member, "need_song", $$v)
              },
              expression: "member.need_song"
            }
          })]
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), (member.need_song == 1) ? _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "label": "送站时间",
        "input-align": "right",
        "error-message-align": "right",
        "placeholder": "请选择送站时间",
        "rules": [{
          required: true,
          message: '请选择送站时间'
        }]
      },
      on: {
        "click": function($event) {
          _vm.thisMemberIndex = index;
          _vm.showSongDate = true
        }
      },
      model: {
        value: (member.song_date),
        callback: function($$v) {
          _vm.$set(member, "song_date", $$v)
        },
        expression: "member.song_date"
      }
    }) : _vm._e(), _vm._v(" "), _c('van-popup', {
      attrs: {
        "position": "bottom"
      },
      model: {
        value: (_vm.showSongDate),
        callback: function($$v) {
          _vm.showSongDate = $$v
        },
        expression: "showSongDate"
      }
    }, [_c('van-datetime-picker', {
      attrs: {
        "type": "datetime",
        "title": "选择年月日",
        "min-date": _vm.minDate,
        "max-date": _vm.maxDate
      },
      on: {
        "confirm": _vm.onSongDateConfirm,
        "cancel": function($event) {
          _vm.showSongDate = false
        }
      },
      model: {
        value: (_vm.currentSongDate),
        callback: function($$v) {
          _vm.currentSongDate = $$v
        },
        expression: "currentSongDate"
      }
    })], 1), _vm._v(" "), (member.need_song == 1) ? _c('div', {
      staticClass: "operate-desc-left"
    }, [_vm._v("从酒店出发海口美兰机场的时间")]) : _vm._e(), _vm._v(" "), (member.need_song == 1) ? _c('van-field', {
      attrs: {
        "label-width": "10em",
        "rules": [{
          required: true,
          message: '请输入车次/航班号'
        }],
        "error-message-align": "right",
        "label": "送站车次/航班号",
        "input-align": "right",
        "clearable": "",
        "placeholder": "请输入车次/航班号"
      },
      model: {
        value: (member.song_code),
        callback: function($$v) {
          _vm.$set(member, "song_code", $$v)
        },
        expression: "member.song_code"
      }
    }) : _vm._e(), _vm._v(" "), (member.need_song == 1) ? _c('div', {
      staticClass: "operate-desc-left"
    }, [_vm._v("海口美兰机场送站航班号")]) : _vm._e(), _vm._v(" "), (member.need_song == 1) ? _c('van-field', {
      attrs: {
        "label-width": "10em",
        "error-message-align": "right",
        "label": "送站额外同行人数",
        "input-align": "right",
        "clearable": "",
        "placeholder": "请输入送站额外同行人数"
      },
      on: {
        "click": function($event) {
          return _vm.Toast('人数不可修改')
        }
      },
      model: {
        value: (member.song_count),
        callback: function($$v) {
          _vm.$set(member, "song_count", $$v)
        },
        expression: "member.song_count"
      }
    }) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n          确认无误\n        ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          修改并保存\n        ")])], 1)], 2)], 1), _vm._v(" "), _c('van-dialog', {
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('div', {
    staticClass: "wxdialog",
    staticStyle: {
      "text-align": "center",
      "padding": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230328/user-0/20230328/4134444823f75613969212acb0adde7c.png"
    }
  }), _vm._v(" \n          长按加好友修改信息\n      ")])]), _vm._v(" "), (_vm.row.member_list.length > 0) ? _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showServiceTypePicker),
      callback: function($$v) {
        _vm.showServiceTypePicker = $$v
      },
      expression: "showServiceTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.serviceTypeColumns,
      "show-toolbar": "",
      "default-index": _vm.row.member_list[_vm.thisMemberIndex].serviceType - 1
    },
    on: {
      "cancel": function($event) {
        _vm.showServiceTypePicker = false
      },
      "confirm": _vm.onServiceConfirm
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f24adba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormStepJiesongConfirm.vue
// module id = 2466
// module chunks = 0